import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    is_weixn:false,//判断是不是微信环境
    screenWidth: '',
    isPc:false
  },
  mutations: {
     //判断是不是微信环境
     checkis_weixn(state) {
      var ua = navigator.userAgent.toLowerCase();
      if(ua.match(/MicroMessenger/i) == "micromessenger") {
        state.is_weixn= true;
      } else {
        state.is_weixn= false;
      }
    },
  },
  actions: {
    checkWindowWidth(context){
      context.state.screenWidth = document.body.clientWidth;
      context.state.isPc=context.state.screenWidth>780?true:false
      window.onresize = () => {
        // console.log(document.body.clientWidth)
        return (() => {
          context.state.screenWidth = document.body.clientWidth;
          context.state.isPc=context.state.screenWidth>780?true:false
        })();
      };
    },
  },
  modules: {
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js